import React from "react";
import { KIcon, KTextInput, KButton, KSwitch } from "@kyburz/kdesign-system";
import useSetState from "../../hooks/useSetState";
import "./customerSelect.css";
import NewCustomer from "./NewCustomer";

const styles = {
  header: {
    display: "inline-block",
  },
  textInput: { margin: "8px 9px 8px 7px" },
  dropdown: {
    width: "100%",
    textAlign: "center",
    marginBottom: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  addCustomerButton: { marginTop: 10, maxWidth: "90%" },
};

const CustomerSelector = ({
  options,
  customer,
  search,
  handleChange,
  handleCustomerChange,
  style = {},
  handleArchivedToggle,
}) => {
  const [{ listOpen, newCompanyPopupOpen, showArchived }, setState] =
    useSetState({
      listOpen: false,
      newCompanyPopupOpen: false,
      showArchived: false,
    });

  const toggleList = () => setState({ listOpen: !listOpen });

  const handleClickCustomer = (item) => {
    handleCustomerChange(item);
    toggleList();
  };

  const handleNewCompanyPopup = (value) => {
    setState({ newCompanyPopupOpen: value });
  };

  return (
    <>
      <div className="dd-wrapper" style={{ ...style }}>
        <div className="dd-header" onClick={toggleList}>
          <img
            alt=""
            className="dd-header-logo"
            width="42"
            height="42"
            src={customer?.photo}
          />
          <div style={styles.header}>
            <p className="dd-header-title">{customer?.name}</p>
            <p className="dd-header-subtitle">{customer?.shortname}</p>
          </div>
          {listOpen ? (
            <KIcon icon="chevron-up" size={20} />
          ) : (
            <KIcon icon="chevron-down" size={20} />
          )}
        </div>

        {listOpen && (
          <div className="dd-dropdown">
            <KTextInput
              value={search}
              name="search"
              onChange={handleChange}
              width="208px"
              placeholder="Search customers..."
              style={styles.textInput}
            />

            <ul className="dd-list">
              {options.map((item) => (
                <li
                  className={`dd-list-item ${
                    customer.name === item.name ? "dd-list-item-active" : ""
                  }`}
                  onClick={() => handleClickCustomer(item)}
                  key={item.name}
                >
                  {item.name}
                </li>
              ))}
            </ul>
            <div style={styles.dropdown as React.CSSProperties}>
              <KButton
                children="Add Company"
                onClick={() => handleNewCompanyPopup(true)}
                icon={<KIcon icon="plus" />}
                size="small"
                style={styles.addCustomerButton}
              />
              <KSwitch
                name="achivedCustomersSwitch"
                onChange={(e) => {
                  setState({ showArchived: e.target.checked });
                  handleArchivedToggle(e.target.checked);
                }}
                checked={showArchived}
                switchLabel="Archived customers"
              />
            </div>
          </div>
        )}
      </div>
      <NewCustomer
        open={newCompanyPopupOpen}
        handleNewCompanyPopup={handleNewCompanyPopup}
        handleClickCustomer={handleClickCustomer}
      />
    </>
  );
};

export default CustomerSelector;
